export enum QUERY_KEY_USER {
  PROFILE = "profile",
  LOGIN = "login",
  PREFERENCES = "preferences",
  PIX = "pix",
}
